import { useExternalDocumentRef } from '@spotify/confidence-external-documents-react';

import { AttachmentChip } from './AttachmentChip';

interface ResourceAttachmentChipProps {
  resourceName: string;
}

// Resolves an ExternalDocument by name and renders it as a chip. Used by
// the chat history to display attachments on previously-sent user messages.
// Falls back to a generic label while loading or if the resource is gone.
export const ResourceAttachmentChip = ({
  resourceName,
}: ResourceAttachmentChipProps) => {
  const { externalDocument } = useExternalDocumentRef({ name: resourceName });
  return (
    <AttachmentChip
      attachment={{
        kind: 'resolved',
        name: resourceName,
        title: externalDocument?.title ?? 'Attached document',
        uri: externalDocument?.source?.uri ?? undefined,
      }}
    />
  );
};
